<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/', 'lieferscheine', 'suche', 'index']"> Lieferscheine </a>
      </li>
      <li>
        <a [routerLink]="['/', 'lieferscheine', deliveryNoteId]">
          @if (deliveryNote) {
            {{ deliveryNote.number }}
          } @else {
            {{ deliveryNoteId }}
          }
        </a>
      </li>
      <li>Retoure-Label erstellen</li>
    </ul>
  </div>
</div>

<div class="page-content page-frame overflow-y-auto flex flex-col gap-4">
  <div class="page-sheet w-full max-w-md mx-auto">
    @if (deliveryNote) {
      <form [formGroup]="shipcloudRetoureForm" (submit)="saveShipcloudRetoure()">
        <fieldset class="bm-fieldset">
          <legend class="bm-fieldset-legend">Versand</legend>

          <ng-select [items]="carriersList" formControlName="carrier" placeholder="carrier" [required]="true">
            <ng-template ng-label-tmp let-item="item">
              {{ item }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
              <div *ngIf="item.toLowerCase().includes(searchTerm.toLowerCase())">
                {{ item }}
              </div>
            </ng-template>
          </ng-select>
          <label class="bm-fieldset-label">Paketbeschreibung</label>
          <textarea class="bm-textarea w-full" formControlName="description"></textarea>
          <span>Bei UPS erforderlich, keine Umlaute, nicht zu lang</span>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="create_retoure_note" />
            Für die Retoure einen neuen Lieferschein erstellen
          </label>
        </fieldset>

        <fieldset class="bm-fieldset">
          <legend class="bm-fieldset-legend">Paket</legend>
          <label class="bm-input w-full">
            <span class="bm-label flex-none w-20">Höhe</span>
            <input type="number" placeholder="Höhe" formControlName="height" required />
            <span class="bm-label w-16">cm</span>
          </label>

          <label class="bm-input w-full">
            <span class="bm-label flex-none w-20">Breite</span>
            <input type="number" placeholder="Breite" formControlName="width" required />
            <span class="bm-label w-16">cm</span>
          </label>

          <label class="bm-input w-full">
            <span class="bm-label flex-none w-20">Länge</span>
            <input type="number" placeholder="Länge" formControlName="length" required />
            <span class="bm-label w-16">cm</span>
          </label>

          <label class="bm-input w-full">
            <span class="bm-label flex-none w-20">Gewicht</span>
            <input type="number" placeholder="Gewicht" formControlName="weight" required />
            <span class="bm-label w-16">kg</span>
          </label>
        </fieldset>

        <div class="flex flex-row gap-2 w-full justify-end col-span-2 mt-4">
          <a class="bm-btn bm-btn-ghost" [routerLink]="['/', 'lieferscheine', deliveryNote.id]">Abbrechen</a>
          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="test" />
            Nur Test
          </label>
          <button
            class="bm-btn bm-btn-primary"
            [disabled]="shipcloudRetoureForm.invalid || submittingLabel"
            type="submit"
          >
            Retoure-Label erstellen
          </button>
        </div>
      </form>
    } @else {
      <div class="flex items-center justify-center">
        <span class="bm-loading bm-loading-spinner"></span>
      </div>
    }
  </div>
</div>
